import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";
import VariantInfo from "HSNDIR/VariantInfo.js";
import gap from 'MOBILE/Gap.js';
import "HSNDIR/Template/MatrixOptions.js";
import "HSNDIR/Widget/ApplePay.js";

import "LIBS/jquery.showhtml.js";
import "LIBS/jquery.visible.js";


HSN.OffCanvas.ProductPreview = (function (parent) {
    __extends(ProductPreview, parent);

    function ProductPreview() {
        var offCanvas = ProductPreview.__super__.constructor.call(this, {
            className: 'product-preview-off-canvas',
            sourceDirection: HSN.OffCanvas.SOURCE_DIRECTION.RIGHT,
            maskPage: true
        });
        this.name = 'HSN.OffCanvas.ProductPreview';
        this.application = HSN.Instance();
        this.commerceService = HSN.Instance()._getCommerceService();
        this._allErrors = [];
        this.eventIdentity = crypto.randomUUID();
        this.heightCalc = HSN.Instance().DeviceInformation.IsMobile ? 'calc(100% - 100px)' : 'calc(100% - 130px)';

        eventHandlers(this);

        HSN.DataLayer.helpers.virtualPageview(null, 'OffCanvas: Product Preview', 'OffCanvas.ProductPreview', 'Product Preview Off Canvas');

        this._variants = null;
        this._variantInfo = null;
        this._productOptionSelectorContainer = null;

        return offCanvas;
    }

    function HandleEsrb(control, offCanvas) {
        var rating = control.data('rating');
        if (rating) {
            //check for cookie
            var isOver17 = false;
            var i, x, y, arRcookies = document.cookie.split(';');
            var arrCookiesLength = arRcookies.length;
            for (i = 0; i < arrCookiesLength; i++) {
                x = arRcookies[i].substr(0, arRcookies[i].indexOf('='));
                y = arRcookies[i].substr(arRcookies[i].indexOf('=') + 1);
                x = x.replace(/^\s+|\s+$/g, '');
                if (x === 'over17') {
                    isOver17 = true;
                }
            }

            if (!isOver17) {
                offCanvas.application.GetRatingModal().Show(rating, control);
                return false;
            }
        }
        return true;
    }
    function HandleAsIs(control, offCanvas) {
        var isAsIs = control.data('isasis');
        if (isAsIs) {
            //check for cookie
            var consentToAsIs = false;
            var i, name, cookies = document.cookie.split(';');
            var cookiesLength = cookies.length;
            for (i = 0; i < cookiesLength; i++) {
                name = cookies[i].substr(0, cookies[i].indexOf('='));
                name = name.replace(/^\s+|\s+$/g, '');
                if (name === 'consentToAsIs') {
                    consentToAsIs = true;
                }
            }

            if (!consentToAsIs) {
                offCanvas.application.GetAsIsModal().Show(control);
                return false;
            }
        }
        return true;
    }
    function HandleAlcohol(control, offCanvas) {
        var isAlcohol = control.data('isalcohol');
        if (isAlcohol) {
            var alcoholFlag = sessionStorage.getItem('alcohol-verification') ? true : false;

            if (!alcoholFlag) {
                offCanvas.application.GetAlcoholModal().Show(control);
                return false;
            }
        }
        return true;
    }

    function eventHandlers(offCanvas) {
        $(offCanvas.Content).on('click', 'input.add-to-bag, .express-buy, input.paypal-express, .apple-pay-button, .pre-order', function () {
            ClearErrors(offCanvas);
            var control = $(this);
            var esrbValue = HandleEsrb(control, offCanvas);
            if (!esrbValue) {
                return esrbValue;
            }
            var asIsValue = HandleAsIs(control, offCanvas);
            if (!asIsValue) {
                return asIsValue;
            }
            var alcoholValue = HandleAlcohol(control, offCanvas);
            if (!alcoholValue) {
                return alcoholValue;
            }

            var productId = control.data('object-id');
            var productWebmId = control.data('object-webmid');

            var singleRequest = GetRequestObject(control, productId, offCanvas);
            if (offCanvas._allErrors.length > 0) {
                DisplayErrors(control, offCanvas);
                return false;
            }

            if (control.data('personalize')) {
                DoPersonalization(offCanvas, singleRequest);
            }
            else {
                var addToBag = {
                    ProductId: productId,
                    WebId: singleRequest.WebId,
                    DeferredFinancing: singleRequest.DeferredFinancing,
                    ExtraFlexPromo: singleRequest.ExtraFlexPromo,
                    ExtraFlexV2: singleRequest.ExtraFlex,
                    ExpressBuy: singleRequest.ExpressBuy,
                    IsApplePay: singleRequest.IsApplePay,
                    Quantity: 1,
                    FlexPayV2: singleRequest.FlexPay,
                    ProgramId: singleRequest.ProgramId,
                    ProgramCode: singleRequest.ProgramCode,
                    Frequency: singleRequest.Frequency,
                    WarrantyWebPId: singleRequest.WarrantyWebPId,
                    WarrantyName: singleRequest.WarrantyName,
                    WarrantyAmount: singleRequest.WarrantyAmount,
                    MatrixId: productWebmId
                }

                HSN.LoaderSetWait('', 5000);
                var currentPage = window.location.href;
                var isOnBagPage = false;
                if (currentPage.indexOf('bag') !== -1) {
                    isOnBagPage = true;
                }
                
                var addToBagWidget = new HSN.Widget.AddToBag();
                addToBagWidget.init({
                    application: offCanvas.application,
                    doFinish: !singleRequest.IsApplePay,
                    isInOffCanvas: true,
                    refreshWhenDone: isOnBagPage
                });
                addToBagWidget.AddToBag(addToBag);

                if (singleRequest.IsApplePay) {
                    HSN.Widget.ApplePay().setupApplePaySession(GetProductPrice(offCanvas.Content));
                }
            }
            return false;
        });
        $(offCanvas.Content).on('click', '.add-hpp-button', function() {
            var storedWarrantySelection = $('#selected-warranty', offCanvas.Content);
            var currentSelection = $(this);

            //update selected warranty
            storedWarrantySelection.val(currentSelection.data('warrantyWebpid'));
            storedWarrantySelection.data('warrantyPrice', currentSelection.data('warrantyPrice'));
            storedWarrantySelection.data('warrantyName', currentSelection.data('warrantyName'));

            //update button status
            currentSelection.removeClass('add-hpp-button');
            currentSelection.addClass('remove-hpp-button');
            currentSelection.val('Remove');

            //hide other warranty options
            $('.add-hpp-button', offCanvas.Content).parents('.warranty-row').hide();

            //send apple pay event
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        });
        $(offCanvas.Content).on('click', '.remove-hpp-button', function () {
            var storedWarrantySelection = $('#selected-warranty', offCanvas.Content);
            var currentSelection = $(this);

            //clear selected warranty
            storedWarrantySelection.val('');
            storedWarrantySelection.removeData();

            //update button status
            currentSelection.removeClass('remove-hpp-button');
            currentSelection.addClass('add-hpp-button');
            currentSelection.val('Add');

            //make all options visible
            $('.add-hpp-button', offCanvas.Content).parents('.warranty-row').show();

            //send apple pay event
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        });
        $(offCanvas.Content).on('click', ".autoship-modal", function (e) {
            e.stopPropagation();
            e.preventDefault();

            var articleSlug = $(this).data("articleSlug");
            var articleId = $(this).data("articleId");
            var webpId = $('#webp_id', offCanvas.Content).val();

            if (isNaN(articleId)) {
                return false;
            }
            if (!articleSlug) {
                articleId = 'default-article-slug';
            }
            HSN.Instance().GetArticleModal().Show('/article/' + articleSlug + '/' + articleId + "?webpid=" + webpId);
        });
        $(offCanvas.Content).on('click', '.warranty-details', function () {
            var warrWebPId = $(this).data('warr-webpid');
            var warrName = $(this).data('name');
            var contentId = jQuery(this).data("content-page-id");
            if (offCanvas.application.DeviceInformation.IsMobile) {
                var link = gap.ConvertLink('/content/squaretrade/' + contentId);
                if (scope._application.DeviceInformation.IsNativeApp) {
                    var gapCommand = gap.BuildGapCommand(link);
                    gap.ExecCommand(gapCommand);
                }
                else {
                    window.location.href = link;
                }
            }
            else {
                HSN.Instance().GetContentModal().Show('/content/content/' + contentId);
            }
            
            return false;
        });
        $(offCanvas.Content).on('change', '#flex-payment-options', function () {
            cmCreateManualLinkClickTag('/product-flexpay?cm_sp=ProductPreview-_-Flexpay-_-Dropdown&cm_re=ProductPreview-_-FlexPay-_-Dropdown', 'ProductPreview');
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        });
        $(offCanvas.Content).on('click', '.add-to-bag-buttons .add-to-favorites', function () {
            HSN.Instance()._getFavoriteService().Favorite($(this).data("objectType"), $(this).data("objectId"), $(this).data("objectId"), {
                scope: HSN.Instance(),
                callback: function (success, favorited) {
                    if (success && favorited) {
                        $('input.add-to-favorites', offCanvas.Content).hide();
                        $('.add-to-fav-success', offCanvas.Content).show();
                    }
                }
            });
        });
    }
    function DoPersonalization(offCanvas, singleRequest) {
        var form = document.createElement('form');
        var inputId = document.createElement('input');
        inputId.setAttribute('type', 'hidden');
        inputId.setAttribute('name', 'Id');
        inputId.setAttribute('value', singleRequest.WebId);
        form.appendChild(inputId);
        var inputQty = document.createElement('input');
        inputQty.setAttribute('type', 'hidden');
        inputQty.setAttribute('name', 'Qty');
        inputQty.setAttribute('value', 1);
        form.appendChild(inputQty);
        var inputFlex = document.createElement('input');
        inputFlex.setAttribute('type', 'hidden');
        inputFlex.setAttribute('name', 'flexpay');
        inputFlex.setAttribute('value', singleRequest.FlexPay);
        form.appendChild(inputFlex);
        var inputExtaFlex = document.createElement('input');
        inputExtaFlex.setAttribute('type', 'hidden');
        inputExtaFlex.setAttribute('name', 'extraFlex');
        inputExtaFlex.setAttribute('value', singleRequest.ExtraFlex);
        form.appendChild(inputExtaFlex);
        var inputExtaFlexPromo = document.createElement('input');
        inputExtaFlexPromo.setAttribute('type', 'hidden');
        inputExtaFlexPromo.setAttribute('name', 'extraFlexPromo');
        inputExtaFlexPromo.setAttribute('value', singleRequest.ExtraFlexPromo);
        form.appendChild(inputExtaFlexPromo);
        var inputDeferred = document.createElement('input');
        inputDeferred.setAttribute('type', 'hidden');
        inputDeferred.setAttribute('name', 'deferredPromo');
        inputDeferred.setAttribute('value', singleRequest.DeferredFinancing);
        form.appendChild(inputDeferred);

        form.action = '/products/personalization/get';
        form.method = 'post';
        var body = document.getElementsByTagName('body')[0];
        body.appendChild(form);
        form.submit();
    }
    function GetRequestObject(buttonScope, objectId, offCanvas) {
        var singleRequest = {
            Errors: new Array()
        };

        singleRequest.ObjectId = objectId;
        singleRequest = HandleObjectIdResponse(GetVariantId(offCanvas.Content, singleRequest.ObjectId, offCanvas), singleRequest);
        singleRequest.DeferredFinancing = GetDeferredPay(offCanvas.Content);
        singleRequest.ExtraFlex = GetExtraFlex(offCanvas.Content);
        singleRequest.ExtraFlexPromo = GetExtraFlexPromo(offCanvas.Content);
        singleRequest.ExpressBuy = GetExpressBuy(buttonScope);
        singleRequest.IsApplePay = GetApplePay(buttonScope);
        singleRequest.FlexPay = GetFlexpay(offCanvas.Content);
        singleRequest.ProgramId = GetAutoshipId(offCanvas.Content);
        singleRequest.ProgramCode = GetAutoshipProgramType(offCanvas.Content);
        singleRequest.Frequency = GetFrequency(offCanvas.Content);
        singleRequest.StartDate = GetStartDate(offCanvas.Content, singleRequest.ProgramId);
        singleRequest.WarrantyWebPId = GetWarrantyWebPId(offCanvas.Content);
        singleRequest.WarrantyName = GetWarrantyName(offCanvas.Content);
        singleRequest.WarrantyAmount = GetWarrantyPrice(offCanvas.Content);

        return singleRequest;
    }
    function HandleObjectIdResponse(objectIdResponse, singleRequest) {
        singleRequest.WebId = objectIdResponse.value;

        if(objectIdResponse.errorList) {
            $.each(objectIdResponse.errorList, function(index, error) {
                singleRequest.Errors.push(error);
            });
        }

        return singleRequest;
    }
    function DisplayErrors(control, offCanvas) {
        var allErrorsLength = offCanvas._allErrors.length;
        if (allErrorsLength > 0) {
            var $errors = $('<div class="errors-pd" tabindex="0"><ul></ul><div></div></div>');

            for (var i = 0; i < allErrorsLength; i++) {
                if (offCanvas._allErrors[i] != null) {
                    $errors.find('ul').append('<li>' + offCanvas._allErrors[i] + '</li>');
                }
            }
            $errors.focus();
            $(control).before($errors);
            $errors.css({
                "top" : control.position().top - $errors.height()
            });
            $(control).addClass('has-error');
            $errors.focus();
        }
    }
    ProductPreview.prototype.BindWidgets = function (offCanvas) {
        var variantJsonString = $('#json-variants', offCanvas.Content.find('.product-option-selector')).html();
        this._variants = variantJsonString ? JSON.parse(variantJsonString) : null;
        this._variantInfo = new VariantInfo(this._variants);

        var productOptionSelector = new HSN.ProductOptionSelector({
            application: HSN.Instance(),
            container: offCanvas.Content.find('.product-option-selector'),
            imageContainer: $('.product-image', offCanvas.Content),
            preSelectedWebId: $('.pre_selected_webid', offCanvas.Content).val(),
            useSimpleMainImage: true,
            variantInfo: this._variantInfo,
            eventIdentity: this.eventIdentity
        }).init();
        offCanvas._productOptionSelectorContainer = offCanvas.Content.find('.product-option-selector');
        var warrantyButtons = $('.hpp-button-container input', offCanvas.Content);
        $.each(warrantyButtons, function () {
            $(this).val($(this).val().toLowerCase())
        });

        HSN.Instance().Events.On(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, function (matrixProductId, url, editBagItemId, editBagIdentity, eventIdentity) {
            if (offCanvas.eventIdentity !== eventIdentity) {
                return;
            }
            Refresh(offCanvas, matrixProductId);
        }, "ProductPreviewOffCanvas");

        HSN.Instance().Events.On(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, function (text, container, eventIdentity) {
            if (offCanvas.eventIdentity !== eventIdentity) {
                return;
            }
            if ((text === 'On Waitlist' || text === 'Extended Delivery') && !$('.product-delivery-message', offCanvas.Content).hasClass('is-override')) {
                $('.product-delivery-message', offCanvas.Content).toggle(false);
            }
            else {
                $('.product-delivery-message', offCanvas.Content).toggle(true);
            }
            $('.product-modal-option-status', offCanvas.Content).last().text(text);
            if (AreButtonsOffScreen(offCanvas)) {
                MakeButtonsFixed(offCanvas);
            }
            HSN.Instance().Events.Trigger(HSN.Widget.ApplePay.EVENT.TOGGLE_APPLE_PAY, CanDoApplePay(offCanvas));
        }, "ProductPreviewOffCanvas");

        HSN.Instance().Events.On(HSN.ProductOptionSelector.EVENT.GROUP_CHANGED, function (isPlusSizeSelected, eventIdentity) {
            if (offCanvas.eventIdentity !== eventIdentity) {
                return;
            }
            if (AreButtonsOffScreen(offCanvas)) {
                MakeButtonsFixed(offCanvas);
            }
        }, "ProductPreviewOffCanvas");

        HSN.Instance().Events.On(HSN.Application.EVENT.FAVORITE_INITIALIZED, function (objectType, objectId) {
            var addToFavoritesButton = $('input.add-to-favorites', offCanvas.Content);

            if ($(addToFavoritesButton).data('object-id') == objectId) {
                addToFavoritesButton.hide();
                $('.add-to-fav-success', offCanvas.Content).show();
            }
        }, "ProductPreviewOffCanvas");

        // Keep display in sync with the variantInfo
        this._variantInfo.onChange(() => {
            ClearErrors(offCanvas);
        });

        var isLessman = $('.add-to-bag-buttons', offCanvas.Content).closest('.buy-selector').hasClass('lessman');
        $('.fixed-container', offCanvas.Content).html($('.add-to-bag-buttons', offCanvas.Content))
        if (isLessman) {
            $('.fixed-container', offCanvas.Content).addClass('lessman');
            $('.product-preview-offcanvas', offCanvas.Content).addClass('lessman-page');
        }

        if (AreButtonsOffScreen(offCanvas)) {
            MakeButtonsFixed(offCanvas);
        }

        var handleResize = function() {
            if (AreButtonsOffScreen(offCanvas)) {
                MakeButtonsFixed(offCanvas);
            }
            else if (IsScrollableContainerNecessary(offCanvas)) {
                MakeButtonsRelative(offCanvas);
            }
        };

        if (window.addEventListener) {
            window.addEventListener('resize', handleResize);
        }
        else {
            window.attachEvent('resize', handleResize);
        }

        HSN.Instance()._getFavoriteService().CheckForFavorites(".favorite-link");
    }

    function GetVariantId(productCardScope, objectId, scope) {
        var hasMatrix = $('.matrix-options', scope._productOptionSelectorContainer).length;

        if (hasMatrix) {
            if ($('.group-options input[name="groupSelect"]', scope._productOptionSelectorContainer).length && !$('.group-options input[name="groupSelect"]:checked', scope._productOptionSelectorContainer).length) {
                scope._allErrors.push('Please select an option');
                return {
                    value: objectId,
                    errorList: ['Please select option first']
                };
            }

            if (!$('.matrix-options a.selected', scope._productOptionSelectorContainer).length && !$('select.matrix-selector option:selected').length) {
                scope._allErrors.push('Please select an option');
                return {
                    value: objectId,
                    errorList: ['Please select option first']
                };
            }
        }

        if (scope._variants === null && hasMatrix) {
            var hasMatrixErrorMessage = $('.tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', scope._productOptionSelectorContainer).length;
            if (!hasMatrixErrorMessage) {
                let labelTxt = $('.tabs-label:first label:not(".waitlist-explainer")', scope._productOptionSelectorContainer).html().toLowerCase();
                labelTxt = labelTxt.includes('select') ? labelTxt : 'select ' + labelTxt;
                var errorMsg = 'Please ' + labelTxt + ' first.';
                scope._allErrors.push(errorMsg);
                $('.tabs-label:first label:not(".waitlist-explainer")', scope._productOptionSelectorContainer).addClass('inline-error');
            }
            else {
                scope._allErrors.push($('.tabs-label:first label:not(".waitlist-explainer") .matrix-selection-error', scope._productOptionSelectorContainer).text());
                $('.tabs-label:first label:not(".waitlist-explainer")', scope._productOptionSelectorContainer).addClass('inline-error');
            }

            return {
                value: objectId,
                errorList: ['Please select option first']
            };
        }

        if (scope._variants != null && scope._variants.length > 0) { 
            var inputLabels = $('label.required-selection', scope._productOptionSelectorContainer);
            var arr =[];
            var isVariantSelectionError = false;

            $.each(inputLabels, function () {
                var inputLabel = $(this);
                var checkedInput = $('input[name="' + $(this).data('selection-name') + '"][data-checked="true"]', scope._productOptionSelectorContainer);
                if (checkedInput.length === 0) {
                    var labelText = inputLabel.text().toLowerCase();
                    if(labelText.length) {
                        scope._allErrors.push('Please select a ' +labelText);
                        inputLabel.addClass('inline-error');
                        isVariantSelectionError = true;
                    }
                }
                else if (checkedInput.length > 0 && !checkedInput.data('is-group')) {
                    arr.push(checkedInput.attr('data-value'));
                }
            });
            
            //Item Sold out
            let variant = scope._variantInfo.SelectedVariant;
            if (!variant) {
                ///scope._allErrors.push('Selection Not Available');
                isVariantSelectionError = true;
            }
            if (variant && variant.Callout && variant.Callout.Name === "SoldOut") {
                scope._allErrors.push("Item Sold Out");
                isVariantSelectionError = true;
            }

            if(isVariantSelectionError) {
                return { value : objectId, errorList : scope._allErrors };
            }

            $.each(scope._variants, function(k, v) {
                if ($(arr).not(v.Codes).length === 0 && $(v.Codes).not(arr).length === 0) {
                    objectId = v.WebId;
                    return;
                }
            });
        }

        return { value: objectId };
    };
    function GetDeferredPay(productCardScope) {
        return $('.template-product-detail-flexpay option:selected', productCardScope).data('deferred-promo') !== undefined;
    };
    function GetExtraFlex(productCardScope) {
        var extraFlex = null;
        if ($('.template-product-detail-flexpay option:selected', productCardScope).data('extra-flex') !== undefined) {
            var optionSelected = parseInt($('.template-product-detail-flexpay option:selected', productCardScope).val());
            var totalFlexAvailable = $('.template-product-detail-flexpay option:not(.extra-flex-payment, .vip-payment)').length;
            var numberOfExtraFlex = (optionSelected - totalFlexAvailable) < 0 ? 0 : optionSelected - totalFlexAvailable;

            extraFlex = numberOfExtraFlex;
        }

        return extraFlex;
    };
    function GetExtraFlexPromo(productCardScope) {
        //NOTE - extraFlexPromo is multi-purposed into the call for both deferred promo id and extra flex
        var extraFlexPromo = null;
        if ($('.template-product-detail-flexpay', productCardScope).length > 0) {
            extraFlexPromo = $('.template-product-detail-flexpay', productCardScope).data('extra-flex-promo');
        }

        var deferredPay = GetDeferredPay(productCardScope);
        if (deferredPay) {
            extraFlexPromo = $('.template-product-detail-flexpay option:selected', productCardScope.Content).data('deferred-promo');
        }

        return extraFlexPromo;
    };
    function GetExpressBuy(buttonObj) {
        var expressBuy = 0;
        if (buttonObj.hasClass('express-buy') || buttonObj.hasClass('apple-pay-button')) {
            expressBuy = 1;
        }

        return expressBuy;
    };
    function GetApplePay(buttonObj) {
        var isApplePay = false;
        if (buttonObj.hasClass('apple-pay-button')) {
            isApplePay = true;
        }
        return isApplePay;
    };
    function GetFlexpay(productCardScope) {
        var flexpay = 1;
        if ($('.template-product-detail-flexpay', productCardScope).length > 0) {
            if ($('.template-product-detail-flexpay option:selected', productCardScope).hasClass('single-payment')) {
                flexpay = 1;
            }
            else if ($('.template-product-detail-flexpay option:selected', productCardScope).hasClass('flex-payment')) {
                var optionSelected = parseInt($('.template-product-detail-flexpay option:selected', productCardScope).val());
                var totalFlexAvailable = $('.template-product-detail-flexpay option:not(.extra-flex-payment, .vip-payment)').length;
                var numberOfFlexPayments = optionSelected > totalFlexAvailable ? totalFlexAvailable : optionSelected;

                flexpay = numberOfFlexPayments;
            }
        }

        return flexpay;
    };
    function GetStartDate(productCardScope, autoshipId) {
        var startDate = null;

        if (autoshipId != null) {
            var theDate = new Date();
            startDate = theDate.getFullYear() + '-' + (theDate.getMonth() + 1) + '-' + theDate.getDate();
        }

        return startDate;
    }
    function GetAutoshipId(productCardScope) {
        var autoshipId = null;
        if ($('#autoship-program-id', productCardScope).length > 0) {
            autoshipId = $('#autoship-program-id', productCardScope).val();
        }

        return autoshipId;
    };
    function GetAutoshipProgramType(productCardScope) {
        var autoshipPgmType = null;
        if ($('#autoship-program-type', productCardScope).length > 0) {
            autoshipPgmType = $('#autoship-program-type', productCardScope).val();
        }

        return autoshipPgmType;
    };
    function GetFrequency(productCardScope) {
        var frequency = parseInt($('#autoship-frequency-options option:selected', productCardScope).val());

        return frequency;
    };
    function GetWarrantyWebPId(productCardScope) {
        var warrantySelected = getWarrantySelected(productCardScope);
        var warrantyDetails = getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.val() : null;
    };
    function GetWarrantyPrice(productCardScope) {
        var warrantySelected = getWarrantySelected(productCardScope);
        var warrantyDetails = getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyPrice') : null;
    };
    function GetWarrantyName(productCardScope) {
        var warrantySelected = getWarrantySelected(productCardScope);
        var warrantyDetails = getWarrantyDetails(productCardScope);

        return warrantySelected ? warrantyDetails.data('warrantyName') : null;
    };
    function getWarrantySelected(warrSelectedScope) {
        var selectedWarranty = $('#selected-warranty', warrSelectedScope);

        return selectedWarranty.length > 0 && typeof(selectedWarranty.val()) !== 'undefined' && selectedWarranty.val().length > 0;
    };
    function getWarrantyDetails(warrDetailsScope) {
        return $('#selected-warranty', warrDetailsScope);
    };
    function GetProductPrice(scope) {
        if ($('span.product-price', scope).length > 0) {
            return $('span.product-price', scope).attr('content');
        }
        else {
            return '.01';
        }
    };
    function ClearErrors(offCanvas) {
        offCanvas._allErrors = [];
        $('.errors-pd', offCanvas.Content).remove();
        $('label[class*="inline-error"]', offCanvas.Content).removeClass('inline-error');
        $('div[class*="errors"]', offCanvas.Content).remove();
        $('input[class*="has-error"]', offCanvas.Content).removeClass('has-error');
        $('input[class*="inline-error"], select[class*="inline-error"]', offCanvas.Content).removeClass('inline-error');
    };
    function CanDoApplePay(offCanvas) {
        if (!HSN.Widget.ApplePay) {
            return false;
        }
        var isValidPaymentOption, isValidWarranty, isValidProductStatus;
        //get flexpay value
        var paymentSelect = $('#flex-payment-options', offCanvas.Content);
        var flexNumber = paymentSelect.val();
        if ((flexNumber > 1 || $('option:selected', paymentSelect).attr('class') === 'vip-payment')) {
            isValidPaymentOption = false;
        }
        else {
            isValidPaymentOption = true;
        }
        //get warranty value
        var selectedWarranty = $('#selected-warranty', offCanvas.Content);
        if(selectedWarranty.val() && selectedWarranty.val().length > 0) {
            isValidWarranty = false;
        }
        else {
            isValidWarranty = true;
        }
        //get extended del/waitlist value
        var text = HSN.ProductOptionSelector.prototype.GetCallout(offCanvas._variantInfo.SelectedVariant);
        if ((text === 'On Waitlist in' || text === 'On Extended Delivery in')) {
            isValidProductStatus = false;
        }
        else {
            isValidProductStatus = true;
        }

        return isValidPaymentOption && isValidWarranty && isValidProductStatus;
    };

    function AreButtonsOffScreen(offCanvas) {
        return !($('.fixed-container .add-to-bag-buttons', offCanvas.Content).last().visible());
    }
    function MakeButtonsFixed(offCanvas) {
        $('.scrollable', offCanvas.Content).css('height', offCanvas.heightCalc);
        $('.fixed-container', offCanvas.Content).css('position', 'fixed');
    }
    function MakeButtonsRelative(offCanvas) {
        $('.scrollable', offCanvas.Content).css('height', 'auto');
        $('.fixed-container', offCanvas.Content).css('position', 'relative');
    }
    function IsScrollableContainerNecessary(offCanvas) {
        var childrenHeight = 0;
        $('.scrollable', offCanvas.Content).children().each(function() {
            let child = $(this);
            childrenHeight = childrenHeight + child.height();
        });
        return $('.scrollable', offCanvas.Content).height() > childrenHeight;
    }

	function TurnOffEvents() {
        HSN.Instance().Events.Off(HSN.ProductOptionSelector.EVENT.MATRIX_OPTION_SELECTED, null, "ProductPreviewOffCanvas");
        HSN.Instance().Events.Off(HSN.ProductOptionSelector.EVENT.OPTION_STATUS_CHANGED, null, "ProductPreviewOffCanvas");
        HSN.Instance().Events.Off(HSN.ProductOptionSelector.EVENT.GROUP_CHANGED, null, "ProductPreviewOffCanvas");
		HSN.Instance().Events.Off(HSN.Application.EVENT.FAVORITE_INITIALIZED, null, "ProductPreviewOffCanvas");
    }

    function Refresh(offCanvas, productIdentity) {
        TurnOffEvents();
        offCanvas.Refresh(productIdentity);
    };

    ProductPreview.prototype._show = function (productIdentity) {
        $.ajax('/products/' + productIdentity + '/preview', {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function (data) {
                var scope = this;
                scope.DisplayContent(data);
                this.BindWidgets(scope);
            },
            error: function () {
                var scope = this;
                scope.HandleError();
            }
        });
    };

	ProductPreview.prototype._hide = function () {
        TurnOffEvents();
    }

    ProductPreview.prototype._refresh = function (productIdentity) {
        $.ajax('/products/' + productIdentity + '/preview', {
            context: this,
            cache: false,
            dataType: 'html',
            data: {},
            success: function (data) {
                var scope = this;
                scope.DisplayContent(data);
                this.BindWidgets(scope);
            },
            error: function () {
                var scope = this;
                scope.HandleError();
            }
        });
    };
    return ProductPreview;
})(HSN.OffCanvas);


// WEBPACK FOOTER //
// ./assets/js/HSN/OffCanvas/Product/ProductPreview.js